module.exports = __webpack_public_path__ + "static/media/owner.797006e1.svg";